import { gql } from '@apollo/client'

export const MilestoneFragments = {
    RecentlyViewedProjectsMilestone: gql`
        fragment recentlyViewedProjectsMilestone on Milestone {
            phaseId
            phase {
                id
                name
                loD
            }
            endDate
            startDate
            actualEndDate
            currentLoD
            targetLoD
        }
    `,
}
